import dayjs from "dayjs";
import React from "react";
import { CashbackProgramAPI } from "../../../providers/CashbackProgramAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { If } from "../../components/control-statements";

import styles from "./CashbackProgramHistoryDrawer.module.css";

export class CashbackProgramHistoryDrawer extends React.Component {
  state = {
    page: { page: 0, limit: 10 },
    historyItems: [],
  };

  async componentDidMount() {
    this.loadHistoryItems();
  }

  async loadHistoryItems() {
    const { brandId } = this.props;
    const { page, historyItems } = this.state;
    const response = await CashbackProgramAPI.getProgramHistory(
      brandId,
      page.page,
      page.limit
    );
    const data = response.getData({
      next: { page: -1, limit: 10 },
      programs: [],
    });
    this.setState({
      historyItems: [...historyItems, ...data.programs],
      page: data.next,
    });
  }

  getFieldName(field) {
    const fields = {
      percentage: "Cashback",
      min_order: "Cashback",
      max_gain: "Cashback",
      expiration_message: "Lembrete",
      "expiration_message.type": "Lembrete",
      "expiration_message.link": "Lembrete",
      "expiration_message.text": "Lembrete",
      "expiration_message.remind_hour": "Lembrete",
      "expiration_message.remind_days_before": "Lembrete",
      message: "Comunicação",
      "message.type": "Comunicação",
      "message.link": "Comunicação",
      "message.text": "Comunicação",
      expiration_days: "Cashback",
    };

    return fields[field] || "Alteração desconhecida";
  }

  getGroupedChangedFields(changed_fields = []) {
    const groupedFields = [];

    if (groupedFields.length > 0) {
      for (const field of changed_fields) {
        groupedFields.push(this.getFieldName(field));
      }
      return [...new Set(groupedFields)];
    }
  }

  getDate(dateString) {
    return dayjs(dateString).format("DD/MM/YYYY");
  }

  getDateDiffDays(startDateString, endDateString) {
    const date1 = dayjs(startDateString);
    return date1.diff(endDateString, "day");
  }

  seeResults(i) {
    const { onSeeResults } = this.props;
    onSeeResults && onSeeResults(i);
  }

  render() {
    const { visible, onClose } = this.props;
    const { historyItems } = this.state;

    if (!historyItems) return;

    return (
      <Drawer
        visible={visible}
        onClose={() => onClose && onClose()}
        title={"Ver passado"}
      >
        <div>
          <div className={styles.events}>
            {historyItems?.map((item, itemIndex) => {
              return (
                <div className={styles.event} key={item?.id}>
                  <div className="d-flex justify-between mb-30">
                    <p className={styles.change}>Alteração do programa</p>
                    <p className={styles.date}>
                      {this.getDate(item?.deleted_at)}
                    </p>
                  </div>
                  <p className={styles.period}>Período considerado</p>
                  <div className="d-flex align-center justify-between">
                    <p className={styles["badge-days"]}>
                      {this.getDateDiffDays(
                        item?.deleted_at || new Date(),
                        item?.created_at
                      )}{" "}
                      dias
                    </p>
                    <p className={styles["period-between"]}>
                      {this.getDate(item?.created_at)} -{" "}
                      {item?.deleted_at
                        ? this.getDate(item?.deleted_at)
                        : "o momento"}
                    </p>
                  </div>
                  <div className={styles.line} />
                  <If cond={item?.changed_fields?.length > 0}>
                    <p className={styles.changes}>Alterações</p>
                  </If>
                  <div className={styles.tags} style={{ flexWrap: "wrap" }}>
                    {this.getGroupedChangedFields(item?.changed_fields)?.map(
                      (field, fieldIndex) => {
                        return (
                          <div
                            className={styles.tag}
                            key={`field-${fieldIndex}`}
                          >
                            •&nbsp;&nbsp;{field}
                          </div>
                        );
                      }
                    )}
                  </div>
                  <Button
                    text="Ver resultados"
                    onClick={() => this.seeResults(item)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </Drawer>
    );
  }
}
